import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { CuesNaviNode, CuesTocService } from '../cues-toc.service';
import { Observable } from 'rxjs';

import { Notify, NotifyService } from '../../shared/notify.service';

@Component({
  selector: 'app-cues-top',
  templateUrl: './cues-top.component.html',
  styleUrls: ['./cues-top.component.scss'],
})
export class CuesTopComponent implements OnInit {
  /**
   * 通知オブジェクト
   */
  public notify: Notify;

  /**
   * メニューノード
   */
  public nodes$?: Observable<CuesNaviNode[]>;

  /**
   * サイドバーが開いている状態であるか
   */
  public isSidebarOpen = false;

  constructor(
    private title: Title,
    private cuesTocService: CuesTocService,
    private notifyService: NotifyService
  ) {
    this.nodes$ = this.cuesTocService.valueSubject;
    this.notify = this.notifyService.getNotify();
    this.title.setTitle(`CUES | Manuals & Technical Documents`);
  }

  ngOnInit(): void {
    this.cuesTocService.getToc();
  }

  /**
   * スマートフォン用サイドバーを開く
   */
  public openSidebar(): void {
    this.isSidebarOpen = true;
  }

  /**
   * スマートフォン用サイドバーを閉じる
   */
  public closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  /**
   * 通知表示を停止する
   */
  closeNotify(): void {
    this.notify = this.notifyService.setNotifyDisable();
  }
}
